import { RequiredError } from "../error/RequiredError.js";
/** Get a required value. */
export function getRequired(value) {
    if (value === null || value === undefined)
        throw new RequiredError();
    return value;
}
/** Is a value not optional? */
export function notOptional(value) {
    return value !== null && value !== undefined;
}
